// extracted by mini-css-extract-plugin
export default {"rating-form":"RatingForm_rating-form__ve94h"};